import { EMPTY_PROPERTY_VALUE } from '../../constants/EmptyPropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { formatPeriodText, getMonthsPerPeriod, getWeeksPerPeriod, isWeeklyOrBiweeklyBillingFrequency, parsePeriodValue } from '../utils/period';

/**
 * Retrieves the numeric value from the period (ISO-8601 duration).
 * Ex: In the case of P3M, this would return 3 representing 3 months.
 * In the case of P14D, this would return 2 representing 2 weeks.
 * @param recurringBillingFrequency
 * @param period ISO-8601 duration string
 * @returns The numeric value representing the term period or null.
 */
import { jsx as _jsx } from "react/jsx-runtime";
function calculateTermPeriod(recurringBillingFrequency, period) {
  var _parsePeriodValue$per, _parsePeriodValue;
  if (recurringBillingFrequency) {
    if (isWeeklyOrBiweeklyBillingFrequency(recurringBillingFrequency)) {
      return getWeeksPerPeriod(period);
    } else {
      return getMonthsPerPeriod(period);
    }
  }
  return (_parsePeriodValue$per = (_parsePeriodValue = parsePeriodValue(period)) === null || _parsePeriodValue === void 0 ? void 0 : _parsePeriodValue.periodValue) !== null && _parsePeriodValue$per !== void 0 ? _parsePeriodValue$per : null;
}
const FormattedPropertyTermPeriod = props => {
  var _ref;
  const {
    placeholder = EMPTY_PROPERTY_VALUE,
    recurringBillingFrequency
  } = props;
  const propertyValue = usePropertyValue();
  const billingFrequency = (_ref = recurringBillingFrequency) !== null && _ref !== void 0 ? _ref : undefined;
  const numericTermPeriod = calculateTermPeriod(billingFrequency, propertyValue);
  const formattedPeriodText = formatPeriodText(numericTermPeriod, billingFrequency);
  return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
    children: numericTermPeriod === null ? placeholder : formattedPeriodText
  }));
};
FormattedPropertyTermPeriod.displayName = 'FormattedPropertyTermPeriod';
export default FormattedPropertyTermPeriod;